//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { Button, ButtonGroup, Flex, Tooltip } from "@chakra-ui/react";
import React from "react";
import { UsageRangeKey } from "./usageRange";

// Tooltip copy says "month(s)"/"months", never a day count: usageRangeFor
// subtracts whole CALENDAR months/years (via moment, clamped - see
// subtractCalendar), not a fixed number of days, so "1 month" and
// "3 months" do not always span exactly 30/90 days (e.g. a 31-day month, or
// a range crossing February) - a day count here would be wrong on exactly
// those months.
const OPTIONS: { key: UsageRangeKey; label: string; tooltip: string }[] = [
  { key: "MONTH_1", label: "1 month", tooltip: "This will show the credit usage for the last month." },
  { key: "MONTH_3", label: "3 months", tooltip: "This will show the credit usage for the last 3 months." },
  { key: "YEAR_1", label: "1 year", tooltip: "This will show the credit usage for the last 12 months." },
];

export const CreditUsageRangeSelector = ({ value, onChange, loading }: { value: UsageRangeKey; onChange: (key: UsageRangeKey) => void; loading?: boolean }) => (
  <Flex justify="flex-start" padding={"32px 0"}>
    <ButtonGroup isAttached>
      {OPTIONS.map((option) => (
        <Tooltip key={option.key} label={option.tooltip} borderRadius="md" hasArrow>
          <Button
            isLoading={loading && value === option.key}
            onClick={() => onChange(option.key)}
            colorScheme={value === option.key ? "green" : "gray"}
            aria-pressed={value === option.key}
          >
            {option.label}
          </Button>
        </Tooltip>
      ))}
    </ButtonGroup>
  </Flex>
);
